// @ts-nocheck — migrated from JS; reactstrap / react-select / layout prop friction.
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Buttons from "./buttons";
import Social from "./social";
import Badges from "./badges";
import Tabs from "./tabs";
import Progress from "./progressBars";
import Timeline from "./timeline";
import Modals from "./modals";
import Tooltip from "./tooltip";
import Popover from "./popover";
import Carousels from "./carousels";
import Columns from "./columns";
import Typography from "./typography";
import Pagination from "./pagination";
import Player from "./player";
import Alert from "./alerts";
import Forms from "./forms";
import FormInputs from "./form-inputs";
import Tables from "./tables";

export default function ShortcodesRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="buttons" replace />} />
      <Route path="buttons" element={<Buttons />} />
      <Route path="social" element={<Social />} />
      <Route path="badges" element={<Badges />} />
      <Route path="tabs" element={<Tabs />} />
      <Route path="progress" element={<Progress />} />
      <Route path="timeline" element={<Timeline />} />
      <Route path="modals" element={<Modals />} />
      <Route path="tooltip" element={<Tooltip />} />
      <Route path="popover" element={<Popover />} />
      <Route path="carousels" element={<Carousels />} />
      <Route path="columns" element={<Columns />} />
      <Route path="typography" element={<Typography />} />
      <Route path="pagination" element={<Pagination />} />
      <Route path="player" element={<Player />} />
      <Route path="alerts" element={<Alert />} />
      <Route path="forms" element={<Forms />} />
      <Route path="forms-inputs" element={<FormInputs />} />
      <Route path="tables" element={<Tables />} />
      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  );
}
